import styleSlider from './../styles/slider.scss';
import styles from '../styles/slider2.module.scss';
import React, { useState } from 'react';
import { Carousel, CarouselItem, CarouselControl, Row, Col } from 'reactstrap';
const Slider = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === props.items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? props.items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = props.items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.key}
      >
        <Row className="mx-0 flex-md-row flex-column-reverse">
          <Col md="5" className="p-0">
            <div className="w-100 p-md-5 py-5 px-2 h-100 d-flex justify-content-center justify-content-md-start align-items-end">
              <div className="text-center text-md-left">
                <h1 className={styles.sliderHeader + '  text-center text-md-left'}>
                  {item.header}
                </h1>
                <div className={styles.borderBlue + " w-50 border border-blue mx-auto ml-md-2 my-4"}> </div>
                <p className={styles.sliderText + ' '}> {item.text} </p>
              </div>
            </div>
          </Col>
          <Col md="7" className="p-0 overflow-x-hidden">
            <div className={styles.imageResponsive}>
              <img src={item.src} alt={item.altText} className="img-fluid lazyload" />
            </div>
          </Col>
        </Row>
      </CarouselItem >
    );
  });

  return (
    <div className="slider2">
      <Carousel

        activeIndex={activeIndex}
        next={next}
        previous={previous}
        pause={props.autoplay}
      >
        {slides}
        <CarouselControl
          cssModule={styleSlider}
          direction="prev"
          directionText=""
          onClickHandler={previous}
        />
        <CarouselControl
          cssModule={styleSlider}
          direction="next"
          directionText=""
          onClickHandler={next}
        />
      </Carousel>
    </div>
  );
};

export default Slider;
